import { Component, ViewChild, Input, Output, EventEmitter, QueryList, ContentChildren, ElementRef, Injectable, inject } from '@angular/core'
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap'
import { Subject } from 'rxjs'

export interface StepState {
  step: number
  state: any
}



@Injectable()
export class ButtonService {

  // Observable string sources
  private buttonSourceSource = new Subject<string>()

  // Observable string streams
  buttonSource$ = this.buttonSourceSource.asObservable()
  buttonHTML(html: string) {
    this.buttonSourceSource.next(html)
  }
}

@Component({
    selector: 'input-dialog-step',
    template: '<ng-content></ng-content>',
    standalone: true
})


export class InputDialogStepComponent  {
  element = inject(ElementRef)
  private buttonService = inject(ButtonService)

  @Input('button') set setButtonText(buttonHTML : string) {
    this.buttonHTML = buttonHTML
    this.buttonService.buttonHTML(buttonHTML)
  }
  @Input('checkValidity') checkValidity : () => boolean = () => true

  buttonHTML = ''
}


@Component({
    selector: 'app-input-dialog',
    templateUrl: './input-dialog.component.html',
    styleUrls: ['./input-dialog.component.scss'],
    providers: [ButtonService],
    standalone: true
})

export class InputDialogComponent {
  private buttonService = inject(ButtonService)
  private modalService = inject(NgbModal)

  @Input('title') title : string = ''
  @Input('button') buttonHTML : string  = ''
  @Output() stepChanged = new EventEmitter<StepState>()
  @Output() cancelled = new EventEmitter<any>()
  @ViewChild('inputModal') inputModal: any
  @ContentChildren(InputDialogStepComponent) steps!: QueryList<InputDialogStepComponent>

  stepsArray: InputDialogStepComponent[] = []
  currentStep: number = 0
  displayFooter: boolean = true
  state: any = null
  public activeModal: NgbActiveModal | undefined

  constructor() {
    const buttonService = this.buttonService;

    buttonService.buttonSource$.subscribe( buttonHTML => {
      this.buttonHTML = buttonHTML
      this.displayFooter = this.buttonHTML !== ''
    })
  }

  setupCurrentStep() {
    this.stepsArray[this.currentStep].element.nativeElement.classList.remove('d-none')
    this.buttonHTML = this.stepsArray[this.currentStep].buttonHTML ?? ''
    this.displayFooter = this.buttonHTML !== ''
  }

  showModal(state: any = null) {
    this.state = state
    this.currentStep = 0
    // tslint:disable-next-line
    this.activeModal = this.modalService.open(this.inputModal, {
      size: 'xl',
      backdrop : 'static',
      keyboard : false
    })
    this.steps.forEach( (step) => step.element.nativeElement.classList.add('d-none'))
    this.stepsArray = this.steps.toArray()
    this.setupCurrentStep()
  }

  advanceToNextStep() {
    if (this.stepsArray[this.currentStep]?.checkValidity()) {
      this.stepsArray[this.currentStep].element.nativeElement.classList.add('d-none')
      this.currentStep ++
      this.stepChanged.emit({
        step: this.currentStep + 1,
        state: this.state
      })
      if (this.currentStep === this.stepsArray.length) {
        this.activeModal!.close()
      } else {
        this.setupCurrentStep()
      }
    }
  }

  actionCancelled() {
    this.cancelled.emit()
    this.activeModal!.close()
  }
}